import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { fmtDate } from "@/lib/constants";

export default function AdminUsers() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/admin/users").then(r => setUsers(r.data)).finally(() => setLoading(false));
  }, []);
  return (
    <div className="space-y-6" data-testid="admin-users">
      <div><h1 className="font-display text-3xl font-bold text-court">Users &amp; Organizations</h1></div>
      <div className="bg-card rounded-sm border border-stone/60  overflow-x-auto">
        {loading ? <div className="p-6 text-muted-foreground">Loading…</div> : (
          <table className="w-full text-sm">
            <thead><tr className="text-left text-xs uppercase tracking-[0.16em] text-muted-foreground">
              <th className="p-3">Name</th><th className="p-3">Email</th><th className="p-3">Role</th><th className="p-3">Status</th><th className="p-3">Joined</th>
            </tr></thead>
            <tbody className="divide-y divide-border">
              {users.map(u => (
                <tr key={u.id} className="hover:bg-slate-50" data-testid={`user-row-${u.email}`}>
                  <td className="p-3 font-medium">{u.name}</td>
                  <td className="p-3">{u.email}</td>
                  <td className="p-3 capitalize">{u.role}</td>
                  <td className="p-3"><span className="inline-flex items-center gap-1.5 rounded-sm px-2.5 py-0.5 text-xs bg-emerald-50 text-emerald-700 ring-1 ring-emerald-200">{u.status}</span></td>
                  <td className="p-3 text-muted-foreground">{fmtDate(u.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
